import { render, staticRenderFns } from "./xmlRelatedRecord.vue?vue&type=template&id=28f5395d&scoped=true&"
import script from "./xmlRelatedRecord.vue?vue&type=script&lang=js&"
export * from "./xmlRelatedRecord.vue?vue&type=script&lang=js&"
import style1 from "./xmlRelatedRecord.vue?vue&type=style&index=1&id=28f5395d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f5395d",
  null
  
)

export default component.exports